module.exports = require("/Users/edwin/Dev/sgnarly.me/src/utils/typography.js")